@if (!isLoadingData) {
    <wdx-ff-form
        [formConfig]="formConfig"
        [formId]="formId"
        [attr.data-cy]="formId"
        [entityId]="entityId"
        [appId]="appId"
        [formDefinition]="formDefinition"
        [formLayout]="formLayout"
        [formData]="formData"
        [isQuickCreate]="isQuickCreate"
        [modalInstanceId]="modalInstanceId"
        [isLoading]="isLoadingData"
        [hasError]="
            $any(
                (formPresentationService.formDefinitionHasError$ | ngrxPush) ||
                    (formDataHasError$ | ngrxPush)
            )
        "
        [isSaving]="$any(formDataIsSaving$ | ngrxPush)"
        [stylingOptions]="formStylingOptions"
        [readonlyMode]="readonlyMode"
        [auditMode]="auditMode"
        [triggerFunction]="triggerFunction$ | ngrxPush"
        [triggerSave]="triggerSave"
        [triggerSaveDraft]="triggerSaveDraft"
        [extraContext]="extraContext"
        (formTitleReceived)="onFormTitleReceived($event)"
        (cancelClicked)="onCancelClick()"
        (saveClicked)="onSaveClick($event)"
        (saveDraftClicked)="onSaveDraftClicked($event)"
        (completionSummaryChanged)="onCompletionSummaryChanged($event)"
        (formEvent)="emitFormEvent($event)"
        (formFunction)="onFormFunction($event)"
        [formFunctionResult]="formFunctionResult"
        [refreshFormData]="refreshFormData"
        [hiddenSections]="hiddenSections"
        [hideVersionSwitcher]="hideVersionSwitcher"
        [patchFormValue]="patchFormValue$ | ngrxPush"
        [extraConfig]="extraConfig"
    >
        <ng-content wdxFFCustomActions select="[wdxFFCustomActions]" />
        <ng-content wdxFFCustomContent0 select="[wdxFFCustomContent0]" />
        <ng-content wdxFFCustomContent1 select="[wdxFFCustomContent1]" />
        <ng-content wdxFFCustomContent2 select="[wdxFFCustomContent2]" />
        <ng-content wdxFFCustomContent3 select="[wdxFFCustomContent3]" />
        <ng-content wdxFFCustomContent4 select="[wdxFFCustomContent4]" />
    </wdx-ff-form>
} @else {
    <div
        class="d-flex h-100 align-items-center justify-content-center text-center"
    >
        <wdx-spinner></wdx-spinner>
    </div>
}
